// extracted by mini-css-extract-plugin
export default {"wrapper":"cnBqzWE0","actions":"y9NRKjbb"};